import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ZoneDataManagerService } from 'src/app/services/zone-data-manager.service';
import { TimelineService } from 'src/app/services/timeline.service';
import { AppComponent } from 'src/app/app.component';


@Component({
  selector: 'app-travel',
  templateUrl: './travel.page.html',
  styleUrls: ['./travel.page.scss'],
})
export class TravelPage implements OnInit {

  game = {
    width: "100%",
    height: 300,
    type: 'AUTO',
    scene: BootScene,
    instance: null
  }

  constructor(private timelineService:TimelineService, private zoneDataManager:ZoneDataManagerService, private modalCtrl:ModalController) { }

  ngOnInit() {
    
    

    this.licznik();

  }

  async licznik()
  {
    console.log('licznik');

    
    await this.awaitFunction(50)
    let locationData = JSON.parse(localStorage.getItem('location'))
    let locationToGo = JSON.parse(localStorage.getItem('locationToGo'))
    var a = locationData.gpsX - locationToGo.gpsX;
    var b = locationData.gpsY - locationToGo.gpsY;

    var c = Math.sqrt( a*a + b*b );


    await this.awaitFunction(c*320) 

    console.log('licznik ok');
    this.dismiss(true);
  }

  async awaitFunction (milisecs) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        resolve();
      }, milisecs);
    });
  };

  

  dismiss(para) {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    //return;

    this.modalCtrl.dismiss({
      'exit': para
    });
  }
}


const SCENES = {
  FIRST: 'FirstScene',
}

class CommonScene extends Phaser.Scene {

  
  myAvatar;
  dot;

  config = {
    type: Phaser.AUTO,
    parent: 'phaser-example',
    width: "100%",
    height: 300,
    pixelArt: true,
    physics: {
        default: 'arcade',
    },
    scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    scene: {
        preload: this.preload,
        create: this.create,
        update: this.update
    }
};



  init () {
    this.cameras.main.setBackgroundColor('#24252A');
    this.game.events.on('destroy', function() {

      console.log('destroy destroy');
    })
  }

  preload ()
  {
      this.load.image('map', 'assets/images/map.jpg');
      this.load.image('myAvatar', 'assets/images/pointer.png');

      var url = 'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexmovetoplugin.min.js';
        this.load.plugin('rexmovetoplugin', url, true);
  }

  create () {


    let locationData = JSON.parse(localStorage.getItem('location'))
    console.log('locationData', locationData.gpsX);

    let locationToGo = JSON.parse(localStorage.getItem('locationToGo'))
    console.log('locationToGo', locationToGo.gpsX);

    this.cameras.main.setBounds(0, 0, 2912, 1305);
    this.cameras.main.centerOn(locationData.gpsX+100, locationData.gpsY);
    
    this.add.image(0, 0, 'map').setOrigin(0).setScrollFactor(1);


    this.dot = this.add.graphics()
            .fillStyle(0xFF0000, 1)
            .fillPoint(0, 0, 5)
            .setPosition(locationToGo.gpsX, locationToGo.gpsY);


    
    

    
    //dot.moveTo(locationToGo.gpsX, locationToGo.gpsY);


    this.myAvatar = this.add.image(locationData.gpsX, locationData.gpsY, 'myAvatar');
    this.myAvatar.setInteractive().on('pointerdown', function(pointer, localX, localY, event){
      console.log('myAvatar', pointer, localX, localY, event)
    });

    //this.cameras.main.setFollowOffset(1000, 5);

    //this.cameras.main.startFollow(this.myAvatar, true, 0, 0, 0, 0);

    
    this.cameras.main.setZoom(3);

    var a = locationData.gpsX - locationToGo.gpsX;
    var b = locationData.gpsY - locationToGo.gpsY;

    var c = Math.sqrt( a*a + b*b );


    console.log('!!distance', c);


    let timer = c * 300

    let tween = this.tweens.add({
        targets: this.myAvatar,
        delay: 500,
        duration: timer-500,
        x: locationToGo.gpsX,
        y: locationToGo.gpsY
    });
  }

  
  
}

class FirstScene extends CommonScene {
  update () {
    //this.updateDirect();
  }
}



export class BootScene extends Phaser.Scene {
  create() {
    this.scene.add(SCENES.FIRST, FirstScene, true);
    this.scene.run(SCENES.FIRST);
  }
}

interface GameInstance extends Phaser.Types.Core.GameConfig {
  instance: Phaser.Game
}



